<template>
  <div class="s-bg">
    <center-header :title="$t('member.dgzhdk')" active="shop" :right="false" :centername="true"></center-header>
    <div class="s-table text-left">
      <div class="float-left">{{$t('member.skrhm')}}</div>
      <div class="float-right">{{offline.payee}}</div>
      <div class="float-left">{{$t('member.yhkh')}}</div>
      <div class="float-right">{{offline.bank_card}}</div>
      <div class="float-left">{{$t('member.khyh')}}</div>
      <div class="float-right">{{offline.bank}}</div>
      <div class="float-left">{{$t('member.khhh')}}</div>
      <div class="float-right">{{offline.bank_no}}</div>
      <div class="clear"></div>
    </div>
    <div class="remarks text-center">
      {{$t('tips.o1')}} <span>scdj01@foxmail.com</span>
    </div>
  </div>
</template>

<script>
  import CenterHeader from './common/CenterHeader'
  export default {
    components: {
      CenterHeader
    },
    data() {
      return {
        offline:''
      }
    },
    created() {
      this.init(this.$store.state.langStates)
    },
    watch: {
      "$route": {
        handler(route) {
          const that = this
          if (route.name === '/offline') {
            that.init(that.$store.state.langStates)
          }
        }
      },
      '$store.state.langStates': function(val) {
        this.init(val)
      }
    },
    methods:{
      init(lang){
        let no = this.$route.query.no
        this.$api.dongjuapi.get_offline(no).then(res=>{
          if(res.data.code==200){
            this.offline = res.data.data
          }
        })
      }
    }
  }
</script>

<style lang="less">
  .s-bg {
    background: #fff;
    padding-bottom: 80px;
  }
  .s-table{
    width: 482px;
    height: 192px;
    margin: 0 auto;
    border: 1px solid #DBDBDB;
    overflow: hidden;
    margin-top: 80px;
    div{
      height: 48px;
      line-height: 48px;
      border-bottom: 1px solid #DBDBDB;
      padding-left: 10px;
    }
    div:nth-child(odd){
      width: 180px;
      background: #F7F5F5;
      border-right: 1px solid #DBDBDB;
    }
    div:nth-child(even){
      width: 300px;
    }
  }
  .remarks{
    padding-top: 12px;
    color: #FF0000;
    span{
      color: #1E2986;
    }
  }
</style>
